import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { DriverProfileDto } from '@/services/Auth/AuthService.dto'

type DriverInitialStateType = {
  phoneNumber: string
  driverName: string
}

const initialState: DriverInitialStateType = {
  phoneNumber: '',
  driverName: '',
}

const DriverSlice = createSlice({
  name: 'driverSlice',
  initialState,
  reducers: {
    commitDriverProfile: (state, action: PayloadAction<DriverProfileDto>) => {
      state.driverName = action.payload.fullName
      state.phoneNumber = action.payload.phoneNumber
    },
  },
})

export const { commitDriverProfile } = DriverSlice.actions

export default DriverSlice.reducer
